import React from 'react';
import { BuyButton as StyledBuyButton } from './BuyButton.styled';


export interface BuyButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
}


export function BuyButton({ 
  children, 
  onClick, 
  className, 
  disabled, 
  loading 
}: BuyButtonProps) {
  return (
    <StyledBuyButton
      onClick={onClick}
      className={className}
      disabled={disabled}
      loading={loading}
    >
      {children}
    </StyledBuyButton>
  );
}
